'use client'
import React, { useEffect, useState } from 'react';
import styled from "styled-components";
import parser from "html-react-parser";

const MyComponent = ({title,desc}) => {

    return (
        <StyledComponent>
            <div className="experience__box__single">
                <h4>{parser(title)}</h4>
                <p>{parser(desc)}</p>
            </div>
        </StyledComponent>
    );
};
const StyledComponent = styled.section`
  position: relative;
  height: 100%;
  .experience__box__single {
    padding: 60px 30px 30px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    height: 100%;
    &:before {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      z-index: 0;

    }


    &__icon {
      position: relative;
      z-index: 2;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 50px;
        height: 50px;
      }

    }

    h4 {
      position: relative;
      z-index: 2;
      color: #FFFFFF;
      margin-bottom: 40px;
    }

    p {
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      color: #FFFFFF;
      margin-top: 40px;
      position: relative;
      z-index: 2;
    }

    @media (min-width: 1550px) {
      p {
        font-size: 16px;
        line-height: 22px;
      }

      h5 {
        font-size: 24px;
        line-height: 32px;
      }
    }
    @media (max-width: 767px) {
      padding: 30px 15px;



      p {
        font-size: 16px;
        line-height: 22px;
        margin-top: 20px;

      }

      h5 {
        font-size: 18px;
        line-height: 22px;
      }
    }
   ;

`
export default MyComponent;